import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {
  Box,
  IconButton,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from '@mui/material'

interface ProjectFooterProps {
  page?: number
  count?: number
  rowsPerPage?: number
  handlePrev?: () => void
  handleNext?: () => void
}

const ProjectFooter = ({
  page = 0,
  count = 0,
  rowsPerPage = 10,
  handlePrev = () => {},
  handleNext = () => {},
}: ProjectFooterProps) => {
  const totalPages = Math.ceil(count / rowsPerPage)
  const startItem = count === 0 ? 0 : page * rowsPerPage + 1
  const endItem = Math.min((page + 1) * rowsPerPage, count)

  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={100} sx={{ borderBottom: 'none', p: 1 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: 'white',
                fontSize: 14,
                px: 1,
              }}
            >
              {startItem}-{endItem} of {totalPages}
            </Typography>

            <IconButton
              onClick={handlePrev}
              disabled={page === 0}
              sx={{ color: 'white' }}
            >
              <KeyboardArrowLeftIcon />
            </IconButton>

            <IconButton
              onClick={handleNext}
              disabled={page + 1 >= totalPages}
              sx={{ color: 'white' }}
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
    </TableFooter>
  )
}

export default ProjectFooter
